import { parsePhoneNumberFromString } from 'libphonenumber-js'

export function formatPhoneNumber(number: string): string {
  try {
    const parsed = parsePhoneNumberFromString(number)
    if (parsed) return parsed.formatInternational()
  } catch {
    // fall through
  }
  return number
}

export function formatDuration(seconds: number): string {
  if (seconds <= 0) return ''
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`
}

export function formatTimeAgo(dateString: string, justNow: string): string {
  const diffMs = Date.now() - new Date(dateString).getTime()
  if (isNaN(diffMs)) return '—'
  const diffMins = Math.floor(diffMs / 60000)
  if (diffMins < 1) return justNow
  if (diffMins < 60) return `${diffMins}m ago`
  const diffHours = Math.floor(diffMins / 60)
  if (diffHours < 24) return `${diffHours}h ago`
  const diffDays = Math.floor(diffHours / 24)
  if (diffDays < 7) return `${diffDays}d ago`
  return new Date(dateString).toLocaleDateString()
}
